/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/rules-of-hooks */

import React, { useState } from 'react';
import { Button, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const WithSelectCreatable = (WrappedComponent) => {
  return (props) => {
    const {
      options = [],
      creatable,
      onCreate,
      onSearch,
      onSelect,
      showSearch,
      loading,
      onBlur,
      ...rest
    } = props;
    const [inputValue, setInputValue] = useState('');

    const handleSearch = (value) => {
      setInputValue(value);
      if (onSearch) {
        onSearch(value);
      }
    };

    const handleSelect = (value, option) => {
      setInputValue('');
      const flatOptionsValue = options.reduce((acc, opt) => {
        if (opt.options) {
          return [...acc, ...opt.options.map((o) => o.value)];
        }
        return [...acc, opt.value];
      }, []);
      if (creatable && !flatOptionsValue.includes(value)) {
        onCreate({
          value,
          label: value,
          isNew: true,
        });
        return;
      }
      if (onSelect) {
        onSelect(value, option);
      }
    };

    const notFoundContent =
      creatable && inputValue ? (
        <Button icon={<PlusOutlined />} type="link" onClick={() => handleSelect(inputValue)}>
          Create &quot;{inputValue}&quot;
        </Button>
      ) : (
        undefined
      );

    return (
      <WrappedComponent
        {...rest}
        showSearch={creatable || showSearch}
        options={options}
        searchValue={inputValue}
        onSearch={handleSearch}
        onSelect={handleSelect}
        notFoundContent={loading ? <Spin size="small" /> : notFoundContent}
        loading={loading}
        onBlur={(e) => {
          setInputValue('');
          if (onBlur) {
            onBlur(e);
          }
        }}
      />
    );
  };
};

export default WithSelectCreatable;
